import InformationPagePopup from "./Popups/InformationPagePopup";
import NanoPopupQueue from "./Popups/NanoPopupQueue";

export default class MandatoryUserAgreement {
  private readonly pageToDisplay?: number;

  constructor() {
    const userAgreementData = $(".mandatory-user-agreement");

    if (userAgreementData.length === 1) {
      this.pageToDisplay = +userAgreementData.attr("data-id");

      NanoPopupQueue.instance.Add(
        InformationPagePopup.instance,
        0,
        InformationPagePopup.instance.Display(this.pageToDisplay),
      );
    }
  }
}
